var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("serie-documental-form", { on: { submit: _vm.submit } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Series documentales"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [
        _vm._v("Nueva serie documental"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }